// @ts-ignore
import $ from "jquery";
// @ts-ignore
import Mousetrap from 'mousetrap';
import {NavigationSectionType} from "../../model2/navigation/@const";

const debug = {
    dev: false,
    head: '{Keyboard}'
};

export enum KeyboardKeys {
    CTRL        = 'ctrl',
    SHIFT       = 'shift',
    CTRL_SHIFT  = 'ctrl+shift'
}

const keysPressed: any = {
    [KeyboardKeys.CTRL]         : false,
    [KeyboardKeys.SHIFT]        : false,
    [KeyboardKeys.CTRL_SHIFT]   : false
}

export const BUS_KEYBOARD_ESCAPE = 'keyboard-key:escape'


const goToSection = (sectionId: NavigationSectionType) => {
    const section = gd.navigationStructure.get(sectionId)
    if (section && section.onClick) {
        section.onClick(section)
    }
}

const home = function(e:any) {
    if (debug.dev) console.log(debug.head," H pressed");

    // dont' let inut n on autofocus
    if (e.preventDefault) e.preventDefault()

    goToSection(NavigationSectionType.HOME)
}

const projects = function(e:any) {
    if (e.preventDefault) { e.preventDefault(); }

    goToSection(NavigationSectionType.PROJECTS)
}

const users = function(e:any) {
    if (e.preventDefault) { e.preventDefault(); }
    goToSection(NavigationSectionType.USERS)
}

const chats = function(e:any) {
    if (e.preventDefault) { e.preventDefault(); }
    goToSection(NavigationSectionType.CHATS)
}

const tools = function(e:any) {
    if (e.preventDefault) { e.preventDefault(); }
    goToSection(NavigationSectionType.TOOLS)
}

const quickAdd = function(e:any) {

    // dont' let inut n on autofocus
    if (e.preventDefault) e.preventDefault()

    if (debug.dev) console.log(debug.head," N pressed");

    if (gd.layout.new.isOpen) { // new task open
        gd.layout.new.close();
    } else {
        gd.openNew();
    }
}

const search = function(e:any) {
    gd.modals.other.showMagicSearch()
}

const fullSessionReset = (e:any) => {
    if (e.preventDefault) { e.preventDefault(); }
    gd.bus.triggerEvent('refresh-timer:full-reset')
}

const attendance = (e: any) => {
    if (!gd.modules.clockInOut.enabled) return

    gd.user.personalViews.attendance.open()
}

export default class KeyboardShortcuts {

    private _isFullScreenDisabled: boolean
    public isCommandPressed: boolean

    constructor() {
        this._isFullScreenDisabled = false
        this.isCommandPressed = false
    }

    init() {

        Mousetrap.addKeycodes({
            65: 'a',
            72: 'h',
            78: 'n',
            71: 'g',
            80: 'p',
            86: 'v',
            83: 's',
            67: 'c',
            84: 't',
            85: 'u',
            79: 'o',
            189: '-',
            187: '+'
        });

        // Mousetrap.bind('a', attendance); - we dont need it anymore
        Mousetrap.bind('n', quickAdd);
        Mousetrap.bind('h', home);
        Mousetrap.bind('t', tools);
        Mousetrap.bind('p', projects)
        Mousetrap.bind('g', search);    // old duplicated i.e. GoTo
        Mousetrap.bind('s', search);
        Mousetrap.bind('u', users);
        Mousetrap.bind('c', chats);

        Mousetrap.bind('escape', this.escape);
        Mousetrap.bind(['shift'], this.shiftDown, 'keydown');
        Mousetrap.bind(['shift'], this.shiftUp, 'keyup');
        Mousetrap.bind(['ctrl', 'command'], this.ctrlDown, 'keydown');
        Mousetrap.bind(['ctrl', 'command'], this.ctrlUp, 'keyup');
        Mousetrap.bind(['ctrl+shift', 'command+shift', 'shift+ctrl', 'shift+command'], this.ctrlShift);
        Mousetrap.bind('space', this.fullScreen);

        Mousetrap.bind('ctrl+shift+r', fullSessionReset);

        $(window).blur(()=>{this.releaseButtons()});
        window.oncontextmenu = ()=>{this.releaseButtons()}
    }

    set isFullScreenDisabled(value: boolean){
        this._isFullScreenDisabled = value
    }

    escape() {

        gd.bus.triggerEvent(BUS_KEYBOARD_ESCAPE);

        if (debug.dev) console.log(debug.head,"Escape called");

        if (gd.layout.contextMenu.isShown) {
            gd.layout.contextMenu.hide()
        }

        if (gd.modal.isOpen) { // MODAL

            gd.modal.hideOnEscape();

        } else if (gd.fullModalApp) { // attachments etc...

            if (['setup', 'logged-out'].indexOf(gd.fullModalApp.name) > -1) {
                // don't allow to close
            } else {
                gd.navigation.goBack();
            }

        } else if (gd.layout.new.isOpen) {
            gd.layout.new.toggle();
        }
        else if (gd.itemView.findLast()) {
            gd.itemView.close(gd.itemView.findLast()!.id)
        }
        else {
            // do nothing
        }

    }

    shiftDown() {
        if (!keysPressed[KeyboardKeys.SHIFT]) {
            keysPressed[KeyboardKeys.SHIFT] = true;
            gd.bus.triggerEvent('keyboard-key:shift');
        }
    }

    shiftUp() {
        if (keysPressed[KeyboardKeys.CTRL_SHIFT]) {
            keysPressed[KeyboardKeys.CTRL_SHIFT] = false;
            gd.bus.triggerEvent('keyboard-key:ctrl+shift');
        }

        if (keysPressed[KeyboardKeys.SHIFT]) {
            keysPressed[KeyboardKeys.SHIFT] = false;
            gd.bus.triggerEvent('keyboard-key:shift');
        }
    }

    ctrlDown = ()=> {
        this.isCommandPressed = true

        if (!keysPressed[KeyboardKeys.CTRL]) {
            keysPressed[KeyboardKeys.CTRL] = true;
            gd.bus.triggerEvent('keyboard-key:ctrl');
        }
    }

    ctrlUp = ()=> {
        this.isCommandPressed = false

        if (keysPressed[KeyboardKeys.CTRL]) {
            keysPressed[KeyboardKeys.CTRL] = false;
            gd.bus.triggerEvent('keyboard-key:ctrl');
        }
    }

    ctrlShift() {
        if (!keysPressed[KeyboardKeys.CTRL_SHIFT]) {
            keysPressed[KeyboardKeys.CTRL_SHIFT] = true
            gd.bus.triggerEvent('keyboard-key:ctrl+shift')
        }

        if (!keysPressed[KeyboardKeys.SHIFT]) {
            keysPressed[KeyboardKeys.SHIFT] = true
            gd.bus.triggerEvent('keyboard-key:shift')
        }

        if (!keysPressed[KeyboardKeys.CTRL]) {
            keysPressed[KeyboardKeys.CTRL] = true
            gd.bus.triggerEvent('keyboard-key:ctrl')
        }
    }

    fullScreen = ()=> {

        if (this._isFullScreenDisabled) {
            return
        }

        gd.bus.triggerEvent('toggle:full-screen', !gd.layout.isFullScreenEnabled());
    }

    setKeyPressed(name:any, value:any) {
        keysPressed[name] = value;
        gd.bus.triggerEvent('keyboard-key:'+name);
    }

    getKeyPressed(name:any) {
        return keysPressed[name];
    }

    releaseButtons() {
        if (_.some(_.values(keysPressed))) {
            _.mapKeys(keysPressed, (value, key)=>{
                return keysPressed[key] = false
            })
            gd.bus.triggerEvent('keyboard-key:unFocus');
        }
    }



}

